<template>
  <div>
    <ul id="tags_list" v-bind:key="tags_key">
      <li v-for="tag in builtin_tags"
          v-bind:key="'builtin_tag_' + tag"
          class="content">
        {{tag}}
      </li>

      <li v-for="tag in user_tags()"
          v-bind:key="'user_tag_' + tag"
          class="content">
        {{tag}} <span class="rm_tag" v-on:click="rm_tag(tag)">-</span>
      </li>
    </ul>

    <div class="subtext" style="margin-top: 3px;">
      TAGS

      <span id="new_tag" v-b-modal.new_tag_dialog>+</span>

      <b-modal id="new_tag_dialog"
               title="New Tag"
               v-on:show="specified_tag = ''"
               v-on:ok="new_tag"
               v-bind:ok-disabled="specified_tag == ''">
        <b-form-input placeholder="Tag" v-model="specified_tag" />
      </b-modal>
    </div>
  </div>
</template>

<script>
import tags from '../../tags'

export default {
  name: 'AccountDetailsTags',

  props : {
    id : String
  },

  data : function(){
    return {
      tags_key : 0,
      specified_tag : '',
    }
  },

  computed : {
    builtin_tags : function(){
      return tags.builtin_tags_for(this.id);
    },
  },

  methods : {
    user_tags : function(){
      return tags.user_tags_for(this.id);
    },

    new_tag : function(){
      tags.create_tag(this.id, this.specified_tag);

      // XXX: tags not reactive (fix)
      this.tags_key += 1;
    },

    rm_tag : function(t){
      tags.rm_tag(this.id, t);

      // XXX: tags not reactive (fix)
      this.tags_key += 1;
    }
  }
}
</script>

<style scoped>
#tags_list{
  list-style: none;
  padding-left: 0;
  margin-bottom: 0;
}

#new_tag{
  color: red;
  cursor: pointer;
}

.rm_tag{
  color: blue;
  cursor: pointer;
}
</style>
